// src/Loan/LoanApplicationForm.jsx
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchLoanEmis,
  clearLoanEmis,
} from "../redux/slices/loan/loanEmiSlice";
import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanApplicationForm.css";
import axios from "axios";

// ✅ Utility functions
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};

const formatAmount = (amount) =>
  !amount ? "0" : `${Number(amount).toLocaleString("en-IN")}`;

const LoanApplicationForm = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const formRef = useRef();

  const {
    emis,
    loading: emiLoading,
    error: emiError,
  } = useSelector((state) => state.loanEmi);
  const {
    loans,
    loading: loanLoading,
    error: loanError,
  } = useSelector((state) => state.loanReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [guarantor, setGuarantor] = useState(null);
  const [customer, setCustomer] = useState(null);

  const [photoUrl, setPhotoUrl] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null); // ✅ Customer Signature
  const [signature, setSignature] = useState(null); // ✅ Customer Signature
  const [guarantorPhoto, setGuarantorPhoto] = useState(null);
  const [guarantorSignature, setGuarantorSignature] = useState(null); // ✅ Guarantor Signature
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(true);
    const [branchSealUrl, setBranchSealUrl] = useState(null);
    const [branchSignUrl, setBranchSignUrl] = useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  // ✅ Fetch profile on mount
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    const branchId = Number(localStorage.getItem("userId")) || 0;


    const loadData = async () => {
      try {
        setLoading(true);

        // ✅ Fetch EMIs and loans
        if (loanId) {
          await dispatch(fetchLoanEmis(loanId));
          if (loans.length === 0) await dispatch(fetchAllLoans());
        }

        const selectedLoan = loans.find((l) => String(l.id) === String(loanId));
        if (!selectedLoan) {
          setLoading(false);
          return;
        }

        
    console.log("selected loan",selectedLoan)

        // ✅ Fetch Customer Details
        if (selectedLoan.customerId) {
          const res = await fetch(
            `https://payyug.in/api/customers-get-userId?userId=${selectedLoan.customerId}&branchId=${branchId}`
          );
          if (res.ok) {
            const data = await res.json();
            console.log("customer details", data.data);
            setCustomer(data.data || data);
          }
        }

        // ✅ Fetch Company Info
        if (profile?.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo) {
              data.logoUrl = `https://payyug.in/${data.logo.replace(
                /^images\//,
                ""
              )}`;
            }
            setCompany(data);
          }
        }

        // ✅ Fetch Guarantor Details
        if (selectedLoan.customerId) {
          try {
            const url = `https://payyug.in/api/nominee-get-all?loanId=${loanId}&branchId=${
              branchId || 0
            }&customerId=${selectedLoan.customerId}`;
            const res = await fetch(url);
            const data = await res.json();

            // console.log("guranter data",data)
            if (
              res.ok &&
              data.success &&
              Array.isArray(data.data) &&
              data.data.length > 0
            ) {
              setGuarantor(data.data[0]); // pick first guarantor record
            } else {
              console.warn("No guarantor data found for loan:", loanId);
            }
          } catch (err) {
            console.error("Error fetching guarantor details:", err);
          }
        }

        // ✅ Fetch Customer KYC (Photo + Signature)
        if (selectedLoan.customerId && profile?.superAdminId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/list-kyc?userId=${selectedLoan.customerId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`
            );
            const data = await res.json();

            console.log("customer kyc:", data.documents);

            if (res.ok && data.documents?.length > 0) {
              const photoDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "photo"
              );
              const signDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "signature"
              );

              // ✅ Member (Customer)
              if (photoDoc?.docImage)
                setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
              if (signDoc?.docImage)
                setSignatureUrl(
                  `https://payyug.in/uploads/${signDoc.docImage}`
                );

              console.log(
                "signature URL :",
                `https://payyug.in/uploads/${signDoc.docImage}`
              );
            }
          } catch (err) {
            console.error("Failed to fetch customer KYC:", err);
          }
        }

        // ✅ Fetch Guarantor KYC (Photo + Signature)
        if (selectedLoan.guarantorId && profile?.superAdminId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/list-kyc?userId=${selectedLoan.guarantorId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`
            );
            const data = await res.json();

            console.log("customer kyc:", data.documents);

            if (res.ok && data.documents?.length > 0) {
              const photoDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "photo"
              );
              const signDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "signature"
              );

              // ✅ Guarantor
              if (photoDoc?.docImage)
                setGuarantorPhoto(
                  `https://payyug.in/uploads/${photoDoc.docImage}`
                );
              if (signDoc?.docImage)
                setGuarantorSignature(
                  `https://payyug.in/uploads/${signDoc.docImage}`
                );

              console.log(
                "signature URL :",
                `https://payyug.in/uploads/${signDoc.docImage}`
              );
            }
          } catch (err) {
            console.error("Failed to fetch guarantor KYC:", err);
          }
        }

        // ✅ Fetch Fee Master
        if (profile?.superAdminId) {
          const res = await fetch(
            // `https://payyug.in/api/all-fee-master?superadminId=${profile.superAdminId}&applicableOn=Disbursal`
             `https://payyug.in/api/all-fee-master?superadminId=${profile.superAdminId}&applicableOn=Disbursal&service=${selectedLoan?.schemeId}`
          );
          const data = await res.json();
          console.log("feees",data)
          if (data.success) setFees(data.data || []);
        }
      } catch (err) {
        console.error("Error loading data:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
    return () => dispatch(clearLoanEmis());
  }, [dispatch, loanId, loans.length, profile?.superAdminId, createdById]);


  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Loan Application`
        );

        const dataArray = res?.data?.data?.[0] || [];

        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }

      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
  const c = customer || {};

  // ✅ Calculate fees (fixed + percentage)
  const calculatedFees = fees.map((fee) => {
    let amount = 0;
    if (fee.type?.toLowerCase() === "percentage") {
      amount = (loan?.loanAmount * fee.value) / 100;
    } else {
      amount = fee.value;
    }
    return { ...fee, calculatedAmount: amount };
  });

  const totalCharges = calculatedFees.reduce(
    (acc, fee) => acc + fee.calculatedAmount,
    0
  );

  // ✅ PDF generator
  const generatePDF = async () => {
    const input = formRef.current;
    if (!input) return;
    const pdf = new jsPDF("p", "mm", "a4",true);
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const canvas = await html2canvas(input, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 10;
    pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - 20;
    while (heightLeft > 0) {
      position = heightLeft - imgHeight + 10;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight - 20;
    }
    pdf.save(
      `${c?.fullName||loan?.userName}_LoanApplication.pdf`
    );
  };

  // ✅ Loading/Error handling
  if (loading || loanLoading || emiLoading)
    return (
      <div className="Print-Loan-Application-Branch-container">Loading...</div>
    );
  if (loanError || emiError)
    return (
      <div className="Print-Loan-Application-Branch-container">
        {loanError || emiError}
      </div>
    );
  if (!loan)
    return (
      <div className="Print-Loan-Application-Branch-container">
        No loan found for Loan ID {loanId}
      </div>
    );

  return (
    <div>
      <div className="Print-Loan-Application-Branch-container" ref={formRef}>
        {/* ---------------- Header ---------------- */}

        {/* ---------------- Header ---------------- */}
        <div className="Print-Loan-Application-Branch-header">
          <div className="Print-Loan-Application-Branch-logo-box">
            <img
              src={
                company?.logoUrl ||
                "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
              }
              alt="logo"
              className="Print-Loan-Application-Branch-logo"
            />
          </div>
          <div className="Print-Loan-Application-Branch-company-details">
            <h2 className="Print-Loan-Application-Branch-company-name">
              {company?.name || "Company Name"}
            </h2>
            <p>
              <b>CIN:</b> {company?.cin || "-"}
            </p>
            <p>
              <b>Regt. Office:</b> {company?.address || "-"}
              {/* <b>Regt. Office:</b> {company?.ddress || "weriyfbup qcpqrhopwinhqguoq cwheruip chpefuib cuw hfwoeicf wperuoi hwe[cfio weuipfhwc[ rhwrfhewhfodhf jwoie rhfewoif ov "} */}
            </p>
            <p>
              <b>Mobile:</b> {company?.contact || "-"}
            </p>
            <p>
              <b>Email:</b> {company?.email || "-"}
            </p>
            <p>
              <b>Website:</b> {company?.domain || "-"}
            </p>
          </div>
          <div style={{visibility:"hidden"}} className="Print-Loan-Application-Branch-logo-box">
            <img
              src={
                company?.logoUrl ||
                "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
              }
              alt="logo"
              className="Print-Loan-Application-Branch-logo"
            />
          </div>
        </div>

        {/* ---------------- Title ---------------- */}
        <h2 className="Print-Loan-Application-Branch-title">
          Loan Application Form
        </h2>

        {/* ---------------- Customer Details ---------------- */}
        <h3 className="loan-application-form-h">Customer Details :</h3>
        <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
          <div style={{ flex: 1 }}>
            <table className="Print-Loan-Application-Branch-table" border="1">
              <tbody>
                <tr>
                  <td colSpan={2}>Branch : {profile?.branchName || "-"}</td>
                  <td colSpan={2}>Date : {formatDate(loan.createdAt)}</td>
                </tr>
                <tr>
                  <td>
                    <span className="tdtextformate">Customer Name :- </span>
                  </td>
                  <td>{c.fullName || loan.userName || "-"}</td>
                  <td>
                    <span className="tdtextformate">Contact No</span>
                  </td>
                  <td>{c.mobileNumber || loan.contactNo || "-"}</td>
                </tr>
                <tr>
                  <td>
                    <span className="tdtextformate">DOB </span>
                  </td>
                  <td>{formatDate(c.dateOfBirth || loan.dob)}</td>
                  <td>
                    <span className="tdtextformate">Gender </span>
                  </td>
                  <td>{c.gender || loan.gender || "-"}</td>
                </tr>

                <tr>
                  <td>
                    <span className="tdtextformate">Father/CareOf </span>
                  </td>
                  <td>{c.guardianName || loan.guardianName || "-"}</td>
                  <td>State/Pincode</td>{" "}
                  <td>
                    {" "}
                    {c.state || loan.state || "-"} -{" "}
                    {c.pincode || loan.pincode || "-"}
                  </td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td colSpan={3}>
                    {c.address || loan.address || "-"},{" "}
                    {c.state || loan.state || "-"} -{" "}
                    {c.pincode || loan.pincode || "-"}
                  </td>
                </tr>
                <tr>
                  <td>Bank</td>
                  <td>{c.bankName || loan.bankName || "-"}</td>
                  <td>
                    <span className="tdtextformate">Branch </span>
                  </td>
                  <td>{c.bankBranch || loan.bankBranch || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              width: "120px",
              height: "120px",
              border: "1px solid #000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={
                photoUrl 
                // c.userPhoto ||
                // loan.userPhoto ||
                // "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
              }
              alt="Customer"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
          </div>
        </div>

        {/* ---------------- Loan Details ---------------- */}
        <h3 className="loan-application-form-h">Loan Details :</h3>
        <table className="Print-Loan-Application-Branch-table" border="1">
          <tbody>
            <tr>
              <td>
                <span className="tdtextformate">Loan ID </span>
              </td>
              <td>{loan.loanAccountNumber || loan.loanNumber}</td>
              <td>
                <span className="tdtextformate"> Loan Amount </span>
              </td>
              <td>{formatAmount(loan.loanAmount)}</td>
            </tr>
            <tr>
              <td>
                <span className="tdtextformate">Purpose </span>
              </td>
              <td>{loan.loanPurpose || "-"}</td>
              <td>
                <span className="tdtextformate">Recovery Type </span>
              </td>
              <td>{loan.loanRecoveryFrequency || "-"}</td>
            </tr>
            <tr>
              <td>
                <span className="tdtextformate">ROI </span>
              </td>
              <td>{loan.loanRoi}%</td>
              <td>
                <span className="tdtextformate">Loan Scheme </span>
              </td>
              <td>
                {loan.loanService} ({loan.loanType})
              </td>
            </tr>

            <tr>
              <td>
                <span className="tdtextformate">Tenure </span>
              </td>
              <td>{loan.loanTenure}</td>
              <td>
                <span className="tdtextformate">Total Payable </span>
              </td>
              <td>{loan.loanPayable} </td>
            </tr>
            <tr>
              <td>
                <span className="tdtextformate">Interest </span>
              </td>
              <td>{loan.loanInterest}</td>
              {/* <td>Total Payable</td>
             <td>{loan.loanPayable} </td> */}
            </tr>
            {calculatedFees.length > 0 && (
              <>
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    <b>Applicable Fees</b>
                  </td>
                </tr>
                {calculatedFees.map((fee, i) => (
                  <tr key={i}>
                    <td colSpan={2}>{fee.name}</td>
                    <td colSpan={2}>{formatAmount(fee.calculatedAmount)}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={2}>
                    <b>Total Charges</b>
                  </td>
                  <td colSpan={2}>
                    <b>{formatAmount(totalCharges)}</b>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>

        <h3 className="loan-application-form-h">Guarantor Details :</h3>
        <div
          className="guarantor-section"
          style={{ display: "flex", gap: "10px", marginTop: "15px" }}
        >
          <div style={{ flex: 1 }}>
            <table className="Print-Loan-Application-Branch-table" border="1">
              <tbody>
                <tr>
                  <td>Guarantor Name</td>
                  <td>{guarantor?.guarantorName || "-"}</td>
                  <td>
                    <span className="tdtextformate">Guarantor Mobile </span>
                  </td>
                  <td>{guarantor?.guarantorMobile || "-"}</td>
                </tr>
                <tr>
                  <td>
                    <span className="tdtextformate">Guarantor Aadhaar </span>
                  </td>
                  <td>{guarantor?.guarantorAadhar || "-"}</td>
                  <td>
                    <span className="tdtextformate">Guarantor PAN </span>
                  </td>
                  <td>{guarantor?.panNumber || "-"}</td>
                </tr>
                <tr>
                  <td>
                    <span className="tdtextformate">
                      Relation with Applicant{" "}
                    </span>
                  </td>
                  <td>{guarantor?.relationApplicant || "-"}</td>
                  {/* <td>Nominee Name</td>
          <td>{guarantor?.nomineeName || "-"}</td> */}
                </tr>
                {/* <tr>
          <td>Nominee DOB</td>
          <td>{formatDate(guarantor?.nomineeDob)}</td>
          <td>Nominee Mobile</td>
          <td>{guarantor?.nomineeNumber || "-"}</td>
        </tr> */}
              </tbody>
            </table>
          </div>

          <div
            style={{
              width: "120px",
              height: "120px",
              border: "1px solid #000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={
                guarantor?.guarantorImage
                  ? `https://payyug.in/uploads/${guarantor.guarantorImage}`
                  : "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
              }
              alt="Guarantor"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
          </div>
        </div>

        {/* ---------------- Signatures ---------------- */}
        {/* Footer Signature Section */}
        {/* <div className="Print-Loan-Application-Branch-footer">
  <table className="Print-Loan-Application-Branch-signature-table" border="1">
    <tbody>
      <tr>
        <td>Member Signature <br /> (सदस्य के हस्ताक्षर)</td>
        <td>Spouse Signature (जीवनसाथी के हस्ताक्षर) </td>
  <td>
                  Guarantor Signature <br /> (जमानदार के हस्ताक्षर)
                </td>
        <td>Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)</td>
      </tr>
    </tbody>
  </table>
</div>  */}

        <div className="Print-Loan-Application-Branch-footer">
          <table
            className="Print-Loan-Application-Branch-signature-table"
            border="1"
          >
            <tbody>
              <tr
              >
                <td>
                  Member Signature <br /> (सदस्य के हस्ताक्षर)
                  <div className="border-line">
                    {signatureUrl && signatureUrl.trim() !== "" ? (
                      <img
                        src={signatureUrl}
                        alt="Member Signature"
                        className="signature-img"
                        style={{
                          width: "160px",
                          height: "70%",
                          marginTop: "14px",
                          marginLeft: "2rem",
                        }}
                      />
                    ) : (
                      <p className="no-sign">No Signature Uploaded</p>
                    )}
                  </div>
                </td>
                <td>
                  Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
                  <div className="border-line"></div>
                </td>
                <td>
                  Guarantor Signature <br /> (जमानदार के हस्ताक्षर)
                  <div className="border-line"></div>
                </td>
                <td>
                   Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
                  <div className="border-line"></div>
              <div className="loan-application-seal-sign">
                {branchSealUrl && (
              <div className="loan-application-seal">
                <img src={branchSealUrl} alt="Seal" />
              </div>
            )}
             {branchSignUrl && (
              <div className="loan-application-sign">
                <img src={branchSignUrl} alt="Signature" />
              </div>
            )}
            </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* <div style={{ height: "60px" }} className="page-break"></div> */}

        {/* Terms & Conditions Section - Add your Custom term here :- */}
        <h3 className="section-label page-break">
          नियम और शर्तें / Terms & Conditions
        </h3>
        <div className="terms-conditions-loanApplication">
          <ol>
            <li>
              उपरोक्त सभी पक्ष निम्निल खत सभी शत व नियम पर अपनी सहमित व्यक्त
              करते हैं कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली
              समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी
              उद्देश्य हेतु नहीं करेंगे।
              <br />
              All parties mentioned above agree to all the terms and conditions
              that the borrower will use this loan amount in accordance with
              microfinance regulations and will not use any part of it for any
              unauthorized purpose.
            </li>
            <li>
              मैं/हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर
              कानूनी कार्य में लिप्त नहीं हैं और न ही किसी न्यायालय में हमारे
              विरुद्ध आपराधिक मामला विचाराधीन है और न ही किसी भी थाने में कोई
              FIR दर्ज है।
              <br />
              The applicant/guarantor confirms they are not involved in any
              illegal activity and no criminal case is pending against them in
              any court or police station.
            </li>
            <li>
              यह है कि मैं/हम किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से
              मुझे/हमको डिफॉल्टर घोषित नहीं किया गया है।
              <br />
              The applicant/guarantor confirms they have not been declared a
              defaulter by any financial institution, bank, or finance company.
            </li>
            <li>
              मैं/हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह
              सक्षम हैं और किसी भी विपरीत परिस्थिति में भुगतान करने में देरी
              नहीं करेंगे।
              <br />
              The applicant/guarantor confirms full ability to pay all
              installments of the loan without delay under any circumstance.
            </li>
            <li>
              कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा, मैं/हम
              उसके साथ विनम्र व्यवहार रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक
              बात नहीं कहेंगे।
              <br />
              Any company employee collecting installments will be treated
              respectfully; no objectionable behavior will be exhibited.
            </li>
            <li>
              मैं/हम नियत तिथियों की सूचना देने से संबंधित जानकारी अपनी किस्तों
              के संपूर्ण भुगतान के लिए नोटिस, रिमाइंडर व इलेक्ट्रॉनिक सूचना करने
              के लिए कंपनी जिम्मेदार नहीं होगी।
              <br />
              The company will not be responsible for reminders or notices
              regarding scheduled payments; responsibility lies with the
              applicant/guarantor.
            </li>
            <li>
              यदि ऋणी या गारंटर अपने व्यवसाय, नौकरी, मूल निवास, मोबाइल नंबर या
              ईमेल आईडी का परिवर्तन करता है तो इसकी सूचना कंपनी को पूर्व में
              लिखित प्रदान करेंगे।
              <br />
              If borrower/guarantor changes occupation, job, residence, mobile
              number, or email, prior written notice must be given to the
              company.
            </li>
            <li>
              मैं/हम वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा
              किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों
              को बैंक में जमा नहीं कराएंगे और ना ही खाते को बंद करेंगे।
              <br />
              We declare that if payment is made by cheque, we will not deposit
              it in the bank or close the account.
            </li>
            <li>
              कंपनी द्वारा संग्रहण संबंधी सुविधाएं जैसे SMS, कॉलिंग, मेल, नोटिस
              आदि प्रदान करने के लिए जो भी सेवा शुल्क अलग से मांगे जाएँगे, वह हम
              प्रदान करेंगे।
              <br />
              Any service charges for collection notices via SMS, calls, or
              email will be borne by us.
            </li>
            <li>
              अनुबंध के अनुसार ग्राहक की पूरी जिम्मेदारी होगी। यदि भविष्य में
              ग्राहक के साथ कोई आकस्मिक घटना (मृत्यु, दिवालिया या गंभीर बीमारी)
              होती है, तो संपूर्ण लोन का भुगतान ग्राहक द्वारा किया जाएगा।
              <br />
              According to the contract, the customer will be fully responsible.
              In case of any unforeseen event in the customer’s life (such as
              death, insolvency, or serious illness), the entire loan shall be
              repaid by the customer.
            </li>
          </ol>
        </div>
      </div>

      {/* ---------------- PDF Button ---------------- */}
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <button onClick={generatePDF} className="branch-loan-card-download-btn">
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default LoanApplicationForm;
